import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { Tooltip } from './tooltip';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** 同時作為 aria-label 與 tooltip 內容，兩者不得省略。 */
  label: string;
  icon: ReactNode;
  tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
  active?: boolean;
}

export function IconButton({
  label,
  icon,
  tooltipSide = 'bottom',
  active = false,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <Tooltip label={label} side={tooltipSide}>
      <button
        type={type}
        aria-label={label}
        className={cn(
          // 常用滑鼠點擊區至少 40px（spec 25.3）。
          'inline-flex size-10 shrink-0 items-center justify-center rounded-full',
          'text-text-muted transition-[background-color,color,transform] duration-300',
          'ease-[var(--ease-gentle)] hover:bg-accent-soft hover:text-text active:scale-[0.94]',
          active && 'bg-accent-soft text-text',
          className,
        )}
        {...rest}
      >
        {icon}
      </button>
    </Tooltip>
  );
}
